import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    BertIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={BertIconImg} preview={false}/>
